<template>
	<div class="headerbg">
		<div :class="missionshow ?'header header1':'header'">
			<div class="lheader">
				<div class="wdl">
					您好,
					<div v-if="!loginshow">
						<span @click="$router.push('/login')">【请登录】</span>
						<span @click="$router.push('/register')">【免费注册】</span>
					</div>
					<div v-if="loginshow">
						<span>{{appdata.myinfo.username}}</span>
						<span class="yqm" @click="oncopy(appdata.myinfo.invite_code)">
							<el-tooltip class="item" effect="dark" content="邀请码,点击复制" placement="bottom">
								<span class="yqm">{{appdata.myinfo.invite_code}}</span>
							</el-tooltip>
						</span>
					</div>
				</div>
			</div>

			<div class="rheaders" v-if="loginshow">
				<div v-if="$route.path != '/home'" class="rheader" @click="$router.push('/home')">首页</div>
				<div :class="type == 'buyer'?'rheader checked':'rheader'" @click="onbuyer()">我是买家</div>
				<div :class="type == 'seller'?'rheader checked':'rheader'" @click="onseller()"
					v-if="appdata.myinfo.is_seller == 1">我是卖家</div>
				<el-badge is-dot class="item" :hidden="count == 0">
					<div class="rheader" v-if="missionshow" @click="ondrawer">任务中心</div>
				</el-badge>
				<div class="rheader" @click="logout()">退出登录</div>
			</div>
		</div>

		<el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose" size="80%" :show-close="false">
			<div class="tabdiv" slot="title">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane name="export">
						<span slot="label">
							<span>导出列表</span>
							<el-badge is-dot class="item" :hidden="exportnum == 0"></el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="import">
						<span slot="label">
							<span>导入列表</span>
							<el-badge is-dot class="item" :hidden="importnum == 0"></el-badge>
						</span>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div class="tablediv">
				<div class="btnbox">
					<el-button type="primary" size="small" @click="onlist">刷新</el-button>
				</div>
				<el-table :data="list" style="width: 100%" border v-if="activeName == 'export'">
					<el-table-column prop="title" label="标题" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" width="80px">
					</el-table-column>
					<el-table-column prop="err_msg" label="错误信息" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center"
						width="170px">
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<div class="cz">
								<span v-if="scope.row.out_file" @click="outFile(scope.row.out_file)">下载</span>
							</div>
						</template>
					</el-table-column>
				</el-table>

				<el-table :data="list" style="width: 100%" border v-if="activeName == 'import'">
					<el-table-column prop="title" label="标题" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" width="80px" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="错误信息" align="center" header-align="center">
						<template slot-scope="scope">
							<el-popover :content="scope.row.err_msg" placement="bottom" trigger="hover">
								<div class="msg" v-html="onzl(scope.row.err_msg)">
									<!-- {{onzl(scope.row.err_msg)}} -->
								</div>
								<div class="p" slot="reference">
									<div v-html="onzl(scope.row.err_msg)"></div>
								</div>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="total_num" label="总条数" width="80px" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="success_num" label="成功条数" width="80px" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center"
						width="170px">
					</el-table-column>
				</el-table>
			</div>

			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, total" :current-page.sync="page" :page-size="pageSize"
					:total="total" v-if="total > 0" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-drawer>

		<div class="rightbox" v-if="loginshow">
			<div class="kg">
				<i class="el-icon-s-unfold" v-if="bshow" @click="bshow = false"></i>
				<i class="el-icon-s-fold" v-if="!bshow" @click="bshow = true"></i>
			</div>
			<div class="blocks" v-if="bshow">
				<div class="block" @click="onshopCart()" v-if="shopcartshow">
					<el-badge is-dot :hidden="shopnum == 0">
						<i class="el-icon-shopping-cart-2"></i>
					</el-badge>
					<span>购物车</span>
				</div>
				<!-- contact_qrcode -->
				<div class="block" v-for="(v,k) in appdata.list.contact_list" :key="k">
					<el-popover placement="left" width="120" trigger="hover">
						<div class="img_p">
							<img :src="v.contact_qrcode">
							<p>{{v.contact}}</p>
						</div>
						<div class="item" @click="oncopy(v.contact)" slot="reference">
							<img src="../assets/image/qq.png" v-if="v.ctype == 1">
							<img src="../assets/image/wx.png" v-if="v.ctype == 2">
							<span>{{v.name}}</span>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'myheader',
		data() {
			return {
				loginshow: false,
				missionshow: false,
				drawer: false,
				activeName: "export",
				list: [],
				page: 1,
				pageSize: 10,
				total: 0,
				shopcartshow: true,
				type: "",
				bshow: true,
				shopnum: 0,
				count: 0,
				exportnum: 0,
				importnum: 0
			}
		},

		inject: ['appdata', 'oncopy'],

		mounted() {
			if (this.$cookies.get('token')) {
				this.loginshow = true;
				this.onclist();
			}

			if (this.isSellerRoute() || this.isBuyerRoute()) {
				this.missionshow = true;
				this.oncount();
			} else {
				this.missionshow = false;
			}

			if (this.$route.path != "/shopCart" && !this.isSellerRoute()) {
				this.shopcartshow = true;
			} else {
				this.shopcartshow = false;
			}

			if (this.isSellerRoute()) {
				this.type = "seller";
				document.title = "我是卖家";
			} else if (this.isBuyerRoute()) {
				this.type = "buyer";
				document.title = "我是买家";
			} else if (this.$route.path.indexOf("/StoreConfig/taobao") === 0) {
				document.title = "直达运动-淘宝";
			} else if (this.$route.path.indexOf("/StoreConfig/miniprogram") === 0) {
				document.title = "直达运动-小程序";
			} else if (this.$route.path.indexOf("/StoreConfig") === 0) {
				document.title = "直达运动-拼多多";
			} else {
				document.title = "直达运动";
			}
		},

		methods: {
			logout() {
				this.$axios.get('api/user/log_out').then(res => {
					if (res.data.code == 0) {
						this.$cookies.remove('token');
						this.$message('退出成功')
						setTimeout(() => {
							this.$router.push({
								path: '/login'
							});
						}, 1000);
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			ondrawer() {
				this.drawer = true;
				this.activeName = 'export';
				this.onlist();
			},

			onlist() {
				var url = "";
				if (this.activeName == 'export') {
					url = "api/user/export_list"
				}
				if (this.activeName == 'import') {
					url = "api/user/import_list"
				}

				var obj = {
					page: this.page,
					limit: this.pageSize
				}
				this.list = [];
				this.$axios.post(url, obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
						this.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})


			},

			handleClose() {
				this.drawer = false;
				this.list = [];
			},

			handleCurrentChange() {
				this.onlist();
			},

			handleClick() {
				this.page = 1;
				this.onlist();
			},

			outFile(url) {
				window.open(url, '_blank');
			},

			onzl(text) {
				if (text) {
					return text.replace(/;/g, '<br/>');
				}

				return "";
			},

			isSellerRoute() {
				var path = this.$route.path || ''
				return path === '/seller' || path.indexOf('/seller/') === 0
			},
			isBuyerRoute() {
				var path = this.$route.path || ''
				return path === '/buyer' || path.indexOf('/buyer/') === 0
			},
			openWorkspace(hashPath) {
				var token = this.$cookies.get('token') || ''
				var origin = window.location.origin
				var pathname = window.location.pathname || '/'
				var search = window.location.search || ''
				if (token && search.indexOf('token=') === -1) {
					search = search && search !== '?'
						? search + '&token=' + encodeURIComponent(token)
						: '?token=' + encodeURIComponent(token)
				}
				var hash = '#' + (hashPath.charAt(0) === '/' ? hashPath : '/' + hashPath)
				var href = origin + pathname + search + hash
				var win = window.open(href, '_blank')
				if (!win) {
					this.$router.push(hashPath)
				}
			},
			onbuyer() {
				if (this.type != 'buyer') {
					this.openWorkspace('/buyer/home')
				} else {
					this.$router.go(0)
				}
			},
			onseller() {
				if (this.type != 'seller') {
					this.openWorkspace('/seller/home')
				} else {
					this.$router.go(0)
				}
			},
			
			onshopCart() {
				if(this.$route.path == "/detail") {
					if(this.$route.query.trade_no) {
						this.$router.push({
							path: '/shopCart',
							query: {
								trade_no: this.$route.query.trade_no
							}
						})
					}else {
						this.$router.push('/shopCart');
					}
				}else {
					this.$router.push('/shopCart');
				}
			},
			
			onclist() {
				var obj = {
					id: "",
					page: 1,
					limit: 100
				};
			
				this.$axios.post('api/user/cart_list', obj).then(res => {
					if (res.data.code == 0) {
						this.shopnum = res.data.data.count;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			oncount() {
				this.$axios.get('/api/user/export_import_unread_count').then(res => {
					if (res.data.code == 0) {
						if(res.data.data) {
							this.count = res.data.data.export + res.data.data.import;
							this.exportnum = res.data.data.export;
							this.importnum = res.data.data.import;
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.headerbg {
		width: 100%;
		border-bottom: 1px solid #eee;
		color: #333;
		font-size: 12px;

		.header {
			width: 1200px;
			height: 36px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;

			span {
				color: #ff4714;
				cursor: pointer;
			}
		}

		.header1 {
			width: 100% !important;
			padding: 0 30px;
			box-sizing: border-box;
		}

		.rheaders {
			display: flex;
		}

		.rheader {
			cursor: pointer;
			margin-left: 6px;
		}

		.checked {
			color: #ff4714;
		}

		.wdl {
			display: flex;
			align-items: center;

			.yqm {
				color: #666;
				padding-left: 5px;
			}
		}
	}

	.tablediv {
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}

	/deep/ .el-drawer__header {
		margin-bottom: 0px;
	}

	.cz {
		span {
			color: #ff4714;
			cursor: pointer;
		}
	}

	.p {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		word-break: break-all;
		-webkit-box-orient: vertical;
	}

	.rightbox {
		top: 40%;
		right: 0;
		position: fixed;
		z-index: 1000;
		overflow: hidden;

		.kg {
			display: flex;
			justify-content: flex-end;
			padding: 5px;

			i {
				font-size: 24px;
				cursor: pointer;
				color: #606266;
			}

			i:hover {
				color: #ff4714;
			}
		}

		.blocks {
			border-radius: 6px 0 0 6px;
			box-shadow: 0 0 16px #0000000d;
		}

		.block {
			width: 64px;
			height: 64px;
			margin-bottom: 0 !important;
			padding: 11px 7px 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			background-color: #fff;
			cursor: pointer;
			box-sizing: border-box;

			i {
				font-size: 26px;
			}

			img {
				width: 24px;
			}

			span {
				text-align: center;
				font-size: 12px;
			}

			.item {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
			}
		}

		.block:hover {
			color: #ff4714;

			i {
				color: #ff4714;
			}
		}
	}

	.msg {
		// width: 400px;
		max-height: 400px;
		overflow: auto;
	}
	
	.img_p {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		img {
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/common/myheader.vue